import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from '@angular/router';
import { takeWhile } from "rxjs/operators";
import * as FileSaver from 'file-saver';

import {
    FvmsCommonService
    ,FvmsApiDtgDownloadService
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.download.etas.request.main.component.html'
    ,providers: []
})
export class DtgDownloadEtasRequestMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    DtgListType = DtgListType;
    fileName:string;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private activatedRoute: ActivatedRoute
        ,private fvmsApiDtgDownloadService:FvmsApiDtgDownloadService
    ) {
        this.fileName = this.activatedRoute.snapshot.queryParamMap.get("fileName");
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickEtasFileDownload(){
        if(this.fileName){
            // let searchInfo = {
            //     fileName:this.fileName
            // };
            // this.fvmsApiDtgDownloadService.etasFileDown(searchInfo)
            //     .pipe(takeWhile(() => this.isContinue))
            //     .subscribe((apiResponse: Blob) => {
            //         FileSaver.saveAs(apiResponse,`${this.fileName}.zip`);
            //     });
            this.fvmsApiDtgDownloadService.etasFileCheck(this.fileName)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe((resCheck: any) => {
                    if(resCheck.resultStatus === "ok"){
                        this.fvmsApiDtgDownloadService.etasFileDown2(this.fileName)
                            .pipe(takeWhile(() => this.isContinue))
                            .subscribe((resDown:Blob) => {
                                FileSaver.saveAs(resDown,`${this.fileName}.zip`);
                            });
                    }else{
                        alert("파일이 존재하지 않습니다");
                    }
                },err => {
                    console.error("resCheck err",err);
                });
        }
    }
}